import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";
import { toast as sonnerToast } from "sonner";

import Icon from "$src/core/components/atoms/Icon";
import Logging from "$src/core/services/logging/logging";

import type { Alerting, AlertOptions, PromptOptions } from "./types";

export { Toaster } from "sonner";

const defaultOptions = {
  position: "bottom-center",
  duration: 5000,
  closeButton: true,
} as const;

const $errorIcon = StyleSheet.create(({ colors, spacing }) => ({
  icon: {
    color: colors.foregroundOnSurface,
    width: spacing(6),
    height: spacing(6),
  },
}));

const $successIcon = StyleSheet.create(({ colors, spacing }) => ({
  icon: {
    color: colors.foregroundOnPositive,
    width: spacing(6),
    height: spacing(6),
  },
}));

const ErrorIcon = () => <Icon name="circle-info" style={$errorIcon.icon} />;

const SuccessIcon = () => <Icon name="check" style={$successIcon.icon} />;

export const alerting: Alerting = {
  error: (message: string, options?: AlertOptions) =>
    sonnerToast.error(message, {
      ...defaultOptions,
      ...options,
      icon: <ErrorIcon />,
      style: {
        backgroundColor: UnistylesRuntime.getTheme().colors.backgroundNegative,
        color: UnistylesRuntime.getTheme().colors.foregroundOnNegative,
        borderWidth: 0,
      },
    }),
  success: (message: string, options?: AlertOptions) =>
    sonnerToast.success(message, {
      ...defaultOptions,
      ...options,
      icon: <SuccessIcon />,
      style: {
        backgroundColor: UnistylesRuntime.getTheme().colors.backgroundPositive,
        color: UnistylesRuntime.getTheme().colors.foregroundOnPositive,
        borderWidth: 0,
      },
    }),
  prompt: (message: string, options: PromptOptions) => {
    if (options.onNeutral && options.neutralLabel) {
      Logging.warn(
        "Neutral button not supported in web prompt: browsers only support two-button confirms; ignoring neutral option.",
      );
    }

    const text = options.title ? `${options.title}\n\n${message}` : message;
    // eslint-disable-next-line no-alert
    if (!window.confirm(text)) {
      options.onCancel?.();
      return;
    }

    options.onConfirm();
  },
  dismiss: (id) => {
    if (id !== undefined) sonnerToast.dismiss(id);
  },
};
